// house list
export const GET_ADDRESS_REQUEST = 'GET_ADDRESS_REQUEST';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAILURE = 'GET_ADDRESS_FAILURE';
export const GET_ERROR_ADDRESS_REQUEST = 'GET_ERROR_ADDRESS_REQUEST';
export const GET_ERROR_ADDRESS_SUCCESS = 'GET_ERROR_ADDRESS_SUCCESS';
export const GET_ERROR_ADDRESS_FAILURE = 'GET_ERROR_ADDRESS_FAILURE';
export const GET_WARNING_ADDRESS_REQUEST = 'GET_WARNING_ADDRESS_REQUEST';
export const GET_WARNING_ADDRESS_SUCCESS = 'GET_WARNING_ADDRESS_SUCCESS';
export const GET_WARNING_ADDRESS_FAILURE = 'GET_WARNING_ADDRESS_FAILURE';
export const GET_ADDRESS_TAGS_REQUEST = 'GET_ADDRESS_TAGS_REQUEST';
export const GET_ADDRESS_TAGS_SUCCESS = 'GET_ADDRESS_TAGS_SUCCESS';
export const GET_ADDRESS_TAGS_FAILURE = 'GET_ADDRESS_TAGS_FAILURE';
export const GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST = 'GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST';
export const GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS = 'GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS';
export const GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE = 'GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE';
export const GET_WARNING_ADDRESS_TAGS_REQUEST = 'GET_WARNING_ADDRESS_TAGS_REQUEST';
export const GET_WARNING_ADDRESS_TAGS_SUCCESS = 'GET_WARNING_ADDRESS_TAGS_SUCCESS';
export const GET_WARNING_ADDRESS_TAGS_FAILURE = 'GET_WARNING_ADDRESS_TAGS_FAILURE';
export const PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST = 'PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST';
export const PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS = 'PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS';
export const PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE = 'PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE';
export const PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST = 'PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST';
export const PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS = 'PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS';
export const PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE = 'PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE';
export const GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST = 'GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST';
export const GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS = 'GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS';
export const GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE = 'GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE';
export const GET_ERROR_ADDRESS_TAGS_REQUEST = 'GET_ERROR_ADDRESS_TAGS_REQUEST';
export const GET_ERROR_ADDRESS_TAGS_SUCCESS = 'GET_ERROR_ADDRESS_TAGS_SUCCESS';
export const GET_ERROR_ADDRESS_TAGS_FAILURE = 'GET_ERROR_ADDRESS_TAGS_FAILURE';
export const PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST = 'PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST';
export const PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS = 'PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS';
export const PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE = 'PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE';
export const PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST = 'PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST';
export const PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS = 'PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS';
export const PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE = 'PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE';
export const GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST = 'GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST';
export const GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS = 'GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS';
export const GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE = 'GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE';
export const POST_ADDRESS_REQUEST = 'POST_ADDRESS_REQUEST';
export const POST_ADDRESS_SUCCESS = 'POST_ADDRESS_SUCCESS';
export const POST_ADDRESS_FAILURE = 'POST_ADDRESS_FAILURE';
export const GET_SEND_ADDRESSES_CONFIRM_REQUEST = 'GET_SEND_ADDRESSES_CONFIRM_REQUEST';
export const GET_SEND_ADDRESSES_CONFIRM_SUCCESS = 'GET_SEND_ADDRESSES_CONFIRM_SUCCESS';
export const GET_SEND_ADDRESSES_CONFIRM_FAILURE = 'GET_SEND_ADDRESSES_CONFIRM_FAILURE';
export const GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST = 'GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST';
export const GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS = 'GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS';
export const GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE = 'GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE';
export const POST_ERROR_CONTACTS_SUCCESS = 'POST_ERROR_CONTACTS_SUCCESS';
export const POST_EXCEL_CONTACTS_REQUEST = 'POST_CONTACTS_REQUEST_EXCEL';
export const POST_EXCEL_CONTACTS_SUCCESS = 'POST_EXCEL_CONTACTS_SUCCESS';
export const POST_EXCEL_CONTACTS_FAILURE = 'POST_EXCEL_CONTACTS_FAILURE';
export const DELETE_ADDRESS_MULTI_REQUEST = 'DELETE_ADDRESS_MULTI_REQUEST';
export const DELETE_ADDRESS_MULTI_SUCCESS = 'DELETE_ADDRESS_MULTI_SUCCESS';
export const DELETE_ADDRESS_MULTI_FAILURE = 'DELETE_ADDRESS_MULTI_FAILURE';
export const PUT_ADDRESS_TAGS_MULTI_REQUEST = 'PUT_ADDRESS_TAGS_MULTI_REQUEST';
export const PUT_ADDRESS_TAGS_MULTI_SUCCESS = 'PUT_ADDRESS_TAGS_MULTI_SUCCESS';
export const PUT_ADDRESS_TAGS_MULTI_FAILURE = 'PUT_ADDRESS_TAGS_MULTI_FAILURE';
export const PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST = 'PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST';
export const PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS = 'PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS';
export const PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE = 'PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE';
export const PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST = 'PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST';
export const PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS = 'PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS';
export const PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE = 'PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE';
export const PUT_ADDRESS_LINK_CORPORATION_REQUEST = 'PUT_ADDRESS_LINK_CORPORATION_REQUEST';
export const PUT_ADDRESS_LINK_CORPORATION_SUCCESS = 'PUT_ADDRESS_LINK_CORPORATION_SUCCESS';
export const PUT_ADDRESS_LINK_CORPORATION_FAILURE = 'PUT_ADDRESS_LINK_CORPORATION_FAILURE';
export const DELETE_ERROR_ADDRESS_MULTI_REQUEST = 'DELETE_ERROR_ADDRESS_MULTI_REQUEST';
export const DELETE_ERROR_ADDRESS_MULTI_SUCCESS = 'DELETE_ERROR_ADDRESS_MULTI_SUCCESS';
export const DELETE_ERROR_ADDRESS_MULTI_FAILURE = 'DELETE_ERROR_ADDRESS_MULTI_FAILURE';
export const DELETE_WARNING_ADDRESS_MULTI_REQUEST = 'DELETE_WARNING_ADDRESS_MULTI_REQUEST';
export const DELETE_WARNING_ADDRESS_MULTI_SUCCESS = 'DELETE_WARNING_ADDRESS_MULTI_SUCCESS';
export const DELETE_WARNING_ADDRESS_MULTI_FAILURE = 'DELETE_WARNING_ADDRESS_MULTI_FAILURE';
export const POST_ERROR_ADDRESS_REQUEST = 'POST_ERROR_ADDRESS_REQUEST';
export const POST_ERROR_ADDRESS_SUCCESS = 'POST_ERROR_ADDRESS_SUCCESS';
export const POST_ERROR_ADDRESS_FAILURE = 'POST_ERROR_ADDRESS_FAILURE';
export const POST_WARNING_ADDRESSES_REQUEST = 'POST_WARNING_ADDRESSES_REQUEST';
export const POST_WARNING_ADDRESSES_SUCCESS = 'POST_WARNING_ADDRESSES_SUCCESS';
export const POST_WARNING_ADDRESSES_FAILURE = 'POST_WARNING_ADDRESSES_FAILURE';
export const POST_WARNING_ADDRESSES_RESTORE_REQUEST = 'POST_WARNING_ADDRESSES_RESTORE_REQUEST';
export const POST_WARNING_ADDRESSES_RESTORE_SUCCESS = 'POST_WARNING_ADDRESSES_RESTORE_SUCCESS';
export const POST_WARNING_ADDRESSES_RESTORE_FAILURE = 'POST_WARNING_ADDRESSES_RESTORE_FAILURE';
export const DELETE_WARNING_ADDRESS_BY_ID_REQUEST = 'DELETE_WARNING_ADDRESS_BY_ID_REQUEST';
export const DELETE_WARNING_ADDRESS_BY_ID_SUCCESS = 'DELETE_WARNING_ADDRESS_BY_ID_SUCCESS';
export const DELETE_WARNING_ADDRESS_BY_ID_FAILURE = 'DELETE_WARNING_ADDRESS_BY_ID_FAILURE';
export const DELETE_ERROR_ADDRESS_BY_ID_REQUEST = 'DELETE_ERROR_ADDRESS_BY_ID_REQUEST';
export const DELETE_ERROR_ADDRESS_BY_ID_SUCCESS = 'DELETE_ERROR_ADDRESS_BY_ID_SUCCESS';
export const DELETE_ERROR_ADDRESS_BY_ID_FAILURE = 'DELETE_ERROR_ADDRESS_BY_ID_FAILURE';
export const POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST = 'POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST';
export const POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS = 'POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS';
export const POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE = 'POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE';
export const POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST = 'POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST';
export const POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS = 'POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS';
export const POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE = 'POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE';
export const POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST = 'POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST';
export const POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS = 'POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS';
export const POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE = 'POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE';
export const POST_WARNING_ADDRESSES_OVERWRITE_REQUEST = 'POST_WARNING_ADDRESSES_OVERWRITE_REQUEST';
export const POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS = 'POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS';
export const POST_WARNING_ADDRESSES_OVERWRITE_FAILURE = 'POST_WARNING_ADDRESSES_OVERWRITE_FAILURE';
export const POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST = 'POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST';
export const POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS = 'POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS';
export const POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE = 'POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE';
export const POST_WARNING_ADDRESSES_MULTI_REQUEST = 'POST_WARNING_ADDRESSES_MULTI_REQUEST';
export const POST_WARNING_ADDRESSES_MULTI_SUCCESS = 'POST_WARNING_ADDRESSES_MULTI_SUCCESS';
export const POST_WARNING_ADDRESSES_MULTI_FAILURE = 'POST_WARNING_ADDRESSES_MULTI_FAILURE';

export const PATCH_CONTACTS_REQUEST = 'PATCH_CONTACTS_REQUEST';
export const PATCH_CONTACTS_SUCCESS = 'PATCH_CONTACTS_SUCCESS';
export const PATCH_CONTACTS_FAILURE = 'PATCH_CONTACTS_FAILURE';
export const GET_ADDRESS_SUGGEST_CORP_REQUEST = 'GET_ADDRESS_SUGGEST_CORP_REQUEST';
export const GET_ADDRESS_SUGGEST_CORP_SUCCESS = 'GET_ADDRESS_SUGGEST_CORP_SUCCESS';
export const GET_ADDRESS_SUGGEST_CORP_FAILURE = 'GET_ADDRESS_SUGGEST_CORP_FAILURE';
export const GET_FAILED_LINK_ADDRESS_REQUEST = 'GET_FAILED_LINK_ADDRESS_REQUEST';
export const GET_FAILED_LINK_ADDRESS_SUCCESS = 'GET_FAILED_LINK_ADDRESS_SUCCESS';
export const GET_FAILED_LINK_ADDRESS_FAILURE = 'GET_FAILED_LINK_ADDRESS_FAILURE';
export const GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST = 'GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST';
export const GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS = 'GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS';
export const GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE = 'GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE';
export const GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST = 'GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST';
export const GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS = 'GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS';
export const GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE = 'GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE';

export const GET_ADDRESS_TOTALS_REQUEST = 'GET_ADDRESS_TOTALS_REQUEST';
export const GET_ADDRESS_TOTALS_SUCCESS = 'GET_ADDRESS_TOTALS_SUCCESS';
export const GET_ADDRESS_TOTALS_FAILURE = 'GET_ADDRESS_TOTALS_FAILURE';

export const POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST = 'POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST';
export const POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS = 'POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS';
export const POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE = 'POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE';

export const CLEAR_ADDRESS_DATA = 'CLEAR_ADDRESS_DATA';

export const GET_EXECUTIVE_LIST_COUNT_REQUEST = 'GET_EXECUTIVE_LIST_COUNT_REQUEST';
export const GET_EXECUTIVE_LIST_COUNT_SUCCESS = 'GET_EXECUTIVE_LIST_COUNT_SUCCESS';
export const GET_EXECUTIVE_LIST_COUNT_FAILURE = 'GET_EXECUTIVE_LIST_COUNT_FAILURE';

export const POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST = 'POST_EXECUTIVE_LIST_TAGS_GETTAGS_REQUEST';
export const POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS = 'POST_EXECUTIVE_LIST_TAGS_GETTAGS_SUCCESS';
export const POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE = 'POST_EXECUTIVE_LIST_TAGS_GETTAGS_FAILURE';
export const POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST = 'POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_REQUEST';
export const POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS = 'POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_SUCCESS';
export const POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE = 'POST_EXECUTIVE_LIST_TAGS_DELETEMULTI_FAILURE';
export const POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST = 'POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_REQUEST';
export const POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS = 'POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_SUCCESS';
export const POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE = 'POST_EXECUTIVE_LIST_TAGS_UPDATETAGNAMEMULTI_FAILURE';
export const POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST = 'POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_REQUEST';
export const POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS = 'POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_SUCCESS';
export const POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE = 'POST_EXECUTIVE_LIST_TAGS_UPDATEMULTI_FAILURE';

export const POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST = 'POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST';
export const POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS = 'POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS';
export const POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE = 'POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE';
export const GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_REQUEST = 'GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_REQUEST';
export const GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS = 'GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS';
export const GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_FAILURE = 'GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_FAILURE';
export const POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST = 'POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST';
export const POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS = 'POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS';
export const POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE = 'POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE';

export const STORE_FILTER_VALUE = 'STORE_FILTER_VALUE';

//Address Detail
export const GET_ADDRESS_BY_ID_REQUEST = 'GET_ADDRESS_BY_ID_REQUEST';
export const GET_ADDRESS_BY_ID_SUCCESS = 'GET_ADDRESS_BY_ID_SUCCESS';
export const GET_ADDRESS_BY_ID_FAILURE = 'GET_ADDRESS_BY_ID_FAILURE';

//account settings
export const GET_SENDERS_REQUEST = 'GET_SENDERS_REQUEST';
export const GET_SENDERS_SUCCESS = 'GET_SENDERS_SUCCESS';
export const GET_SENDERS_FAILURE = 'GET_SENDERS_FAILURE';
export const POST_SENDER_REQUEST = 'POST_SENDER_REQUEST';
export const POST_SENDER_SUCCESS = 'POST_SENDER_SUCCESS';
export const POST_SENDER_FAILURE = 'POST_SENDER_FAILURE';
export const PUT_SENDER_REQUEST = 'PUT_SENDER_REQUEST';
export const PUT_SENDER_SUCCESS = 'PUT_SENDER_SUCCESS';
export const PUT_SENDER_FAILURE = 'PUT_SENDER_FAILURE';
export const DELETE_SENDER_REQUEST = 'DELETE_SENDER_REQUEST';
export const DELETE_SENDER_SUCCESS = 'DELETE_SENDER_SUCCESS';
export const DELETE_SENDER_FAILURE = 'DELETE_SENDER_FAILURE';
export const GET_USERS_ME_REQUEST = 'GET_USERS_ME_REQUEST';
export const GET_USERS_ME_SUCCESS = 'GET_USERS_ME_SUCCESS';
export const GET_USERS_ME_FAILURE = 'GET_USERS_ME_FAILURE';
export const RESET_LATEST_EXPIRED_PLAN = 'RESET_LATEST_EXPIRED_PLAN';
export const GET_PROXY_LOGIN_USER_REQUEST = 'GET_PROXY_LOGIN_USER_REQUEST';
export const GET_PROXY_LOGIN_USER_SUCCESS = 'GET_PROXY_LOGIN_USER_SUCCESS';
export const GET_PROXY_LOGIN_USER_FAILURE = 'GET_PROXY_LOGIN_USER_FAILURE';
export const DELETE_USERS_ME_REQUEST = 'DELETE_USERS_ME_REQUEST';
export const DELETE_USERS_ME_SUCCESS = 'DELETE_USERS_ME_SUCCESS';
export const DELETE_USERS_ME_FAILURE = 'DELETE_USERS_ME_FAILURE';
export const PATCH_USERS_ME_REQUEST = 'PATCH_USERS_ME_REQUEST';
export const PATCH_USERS_ME_SUCCESS = 'PATCH_USERS_ME_SUCCESS';
export const PATCH_USERS_ME_FAILURE = 'PATCH_USERS_ME_FAILURE';
export const PUT_USERS_ME_PAYMENT_REQUEST = 'PUT_USERS_ME_PAYMENT_REQUEST';
export const PUT_USERS_ME_PAYMENT_SUCCESS = 'PUT_USERS_ME_PAYMENT_SUCCESS';
export const PUT_USERS_ME_PAYMENT_FAILURE = 'PUT_USERS_ME_PAYMENT_FAILURE';
export const POST_USERS_ME_PAYMENT_REQUEST = 'POST_USERS_ME_PAYMENT_REQUEST';
export const POST_USERS_ME_PAYMENT_SUCCESS = 'POST_USERS_ME_PAYMENT_SUCCESS';
export const POST_USERS_ME_PAYMENT_FAILURE = 'POST_USERS_ME_PAYMENT_FAILURE';
export const POST_POSTCODE_REQUEST = 'POST_POSTCODE_REQUEST';
export const POST_POSTCODE_SUCCESS = 'POST_POSTCODE_SUCCESS';
export const POST_POSTCODE_FAILURE = 'POST_POSTCODE_FAILURE';
export const POST_MULTI_POSTCODES_REQUEST = 'POST_MULTI_POSTCODES_REQUEST';
export const POST_MULTI_POSTCODES_SUCCESS = 'POST_MULTI_POSTCODES_SUCCESS';
export const POST_MULTI_POSTCODES_FAILURE = 'POST_MULTI_POSTCODES_FAILURE';
export const REMOVE_CRM = "REMOVE_CRM";
export const POST_USERS_ME_PLANS_REQUEST = 'POST_USERS_ME_PLANS_REQUEST';
export const POST_USERS_ME_PLANS_SUCCESS = 'POST_USERS_ME_PLANS_SUCCESS';
export const POST_USERS_ME_PLANS_FAILURE = 'POST_USERS_ME_PLANS_FAILURE';
export const POST_USERS_PAYMENTS_AND_PLANS_REQUEST = 'POST_USERS_PAYMENTS_AND_PLANS_REQUEST';
export const POST_USERS_PAYMENTS_AND_PLANS_SUCCESS = 'POST_USERS_PAYMENTS_AND_PLANS_SUCCESS';
export const POST_USERS_PAYMENTS_AND_PLANS_FAILURE = 'POST_USERS_PAYMENTS_AND_PLANS_FAILURE';
export const GET_CHILD_USERS_REQUEST = 'GET_CHILD_USERS_REQUEST';
export const GET_CHILD_USERS_SUCCESS = 'GET_CHILD_USERS_SUCCESS';
export const GET_CHILD_USERS_FAILURE = 'GET_CHILD_USERS_FAILURE';
export const POST_CHILD_USER_REQUEST = 'POST_CHILD_USER_REQUEST';
export const POST_CHILD_USER_SUCCESS = 'POST_CHILD_USER_SUCCESS';
export const POST_CHILD_USER_FAILURE = 'POST_CHILD_USER_FAILURE';
export const GET_CHILD_USER_BY_ID_REQUEST = 'GET_CHILD_USER_BY_ID_REQUEST';
export const GET_CHILD_USER_BY_ID_SUCCESS = 'GET_CHILD_USER_BY_ID_SUCCESS';
export const GET_CHILD_USER_BY_ID_FAILURE = 'GET_CHILD_USER_BY_ID_FAILURE';
export const PUT_CHILD_USERS_AUTHORITY_REQUEST = 'PUT_CHILD_USERS_AUTHORITY_REQUEST';
export const PUT_CHILD_USERS_AUTHORITY_SUCCESS = 'PUT_CHILD_USERS_AUTHORITY_SUCCESS';
export const PUT_CHILD_USERS_AUTHORITY_FAILURE = 'PUT_CHILD_USERS_AUTHORITY_FAILURE';
export const PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST = 'PATCH_CHILD_USER_AUTHORITY_BY_ID_REQUEST';
export const PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS = 'PATCH_CHILD_USER_AUTHORITY_BY_ID_SUCCESS';
export const PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE = 'PATCH_CHILD_USER_AUTHORITY_BY_ID_FAILURE';
export const DELETE_CHILD_USERS_REQUEST = 'DELETE_CHILD_USERS_REQUEST';
export const DELETE_CHILD_USERS_SUCCESS = 'DELETE_CHILD_USERS_SUCCESS';
export const DELETE_CHILD_USERS_FAILURE = 'DELETE_CHILD_USERS_FAILURE';
export const GET_PROXY_LOGIN_CHILD_USER_REQUEST = 'GET_PROXY_LOGIN_CHILD_USER_REQUEST';
export const GET_PROXY_LOGIN_CHILD_USER_SUCCESS = 'GET_PROXY_LOGIN_CHILD_USER_SUCCESS';
export const GET_PROXY_LOGIN_CHILD_USER_FAILURE = 'GET_PROXY_LOGIN_CHILD_USER_FAILURE';
export const GET_PROXY_LOGIN_PARENT_USER_REQUEST = 'GET_PROXY_LOGIN_PARENT_USER_REQUEST';
export const GET_PROXY_LOGIN_PARENT_USER_SUCCESS = 'GET_PROXY_LOGIN_PARENT_USER_SUCCESS';
export const GET_PROXY_LOGIN_PARENT_USER_FAILURE = 'GET_PROXY_LOGIN_PARENT_USER_FAILURE';

//login, logout, signup, request password, reset password

export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const LOG_IN_REQUEST = 'LOG_IN_REQUEST';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE';

export const REQUEST_PASSWORD_REQUEST = 'REQUEST_PASSWORD_REQUEST';
export const REQUEST_PASSWORD_SUCCESS = 'REQUEST_PASSWORD_SUCCESS';
export const REQUEST_PASSWORD_FAILURE = 'REQUEST_PASSWORD_FAILURE';
export const RESET_FORGET_PASSWORD = 'RESET_FORGET_PASSWORD';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const LOG_OUT_REQUEST = 'LOG_OUT_REQUEST';
export const LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS';
export const LOG_OUT_FAILURE = 'LOG_OUT_FAILURE';

export const GET_LETTER_PLANS_REQUEST = 'GET_LETTER_PLANS_REQUEST';
export const GET_LETTER_PLANS_SUCCESS = 'GET_LETTER_PLANS_SUCCESS';
export const GET_LETTER_PLANS_FAILURE = 'GET_LETTER_PLANS_FAILURE';

export const DISABLE_SIGNIN = "DISABLE_SIGNIN";
export const ENABLE_SIGNIN = "ENABLE_SIGNIN";

//errors
export const HTTP_400_BAD_REQUEST = 'HTTP_400_BAD_REQUEST';
export const HTTP_401_UNAUTHORIZED = 'HTTP_401_UNAUTHORIZED';
export const HTTP_404_NOT_FOUND = 'HTTP_404_NOT_FOUND';
export const HTTP_405_METHOD_NOT_ALLOWED = 'HTTP_405_METHOD_NOT_ALLOWED';
export const HTTP_500_INTERNAL_SERVER_ERROR = 'HTTP_500_INTERNAL_SERVER_ERROR';

//notifications
export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';
export const GET_NOTIFICATIONS_LATEST_REQUEST = 'GET_NOTIFICATIONS_LATEST_REQUEST';
export const GET_NOTIFICATIONS_LATEST_SUCCESS = 'GET_NOTIFICATIONS_LATEST_SUCCESS';
export const GET_NOTIFICATIONS_LATEST_FAILURE = 'GET_NOTIFICATIONS_LATEST_FAILURE';
export const POST_NOTIFICATIONS_MARK_REQUEST = 'POST_NOTIFICATIONS_MARK_REQUEST';
export const POST_NOTIFICATIONS_MARK_SUCCESS = 'POST_NOTIFICATIONS_MARK_SUCCESS';
export const POST_NOTIFICATIONS_MARK_FAILURE = 'POST_NOTIFICATIONS_MARK_FAILURE';

//Posto executive list
export const GET_EXECUTIVE_LIST_REQUEST = 'GET_EXECUTIVE_LIST_REQUEST';
export const GET_EXECUTIVE_LIST_SUCCESS = 'GET_EXECUTIVE_LIST_SUCCESS';
export const GET_EXECUTIVE_LIST_FAILURE = 'GET_EXECUTIVE_LIST_FAILURE';
export const GET_EXECUTIVE_LIST_BY_ID_REQUEST = 'GET_EXECUTIVE_LIST_BY_ID_REQUEST';
export const GET_EXECUTIVE_LIST_BY_ID_SUCCESS = 'GET_EXECUTIVE_LIST_BY_ID_SUCCESS';
export const GET_EXECUTIVE_LIST_BY_ID_FAILURE = 'GET_EXECUTIVE_LIST_BY_ID_FAILURE';
export const GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST = 'GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST';
export const GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS = 'GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS';
export const GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE = 'GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE';
export const CLEAR_EXECUTIVE_LIST = 'CLEAR_EXECUTIVE_LIST';

// attack list
export const CLEAR_ATTACK_LIST_STATE = 'CLEAR_ATTACK_LIST_STATE';
// 2段階API: Step 1 - URL解析
export const POST_ATTACK_LIST_ANALYZE_URL_REQUEST = 'POST_ATTACK_LIST_ANALYZE_URL_REQUEST';
export const POST_ATTACK_LIST_ANALYZE_URL_SUCCESS = 'POST_ATTACK_LIST_ANALYZE_URL_SUCCESS';
export const POST_ATTACK_LIST_ANALYZE_URL_FAILURE = 'POST_ATTACK_LIST_ANALYZE_URL_FAILURE';
// 2段階API: Step 2 - タグ付け実行
export const POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST = 'POST_ATTACK_LIST_EXECUTE_TAGGING_REQUEST';
export const POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS = 'POST_ATTACK_LIST_EXECUTE_TAGGING_SUCCESS';
export const POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE = 'POST_ATTACK_LIST_EXECUTE_TAGGING_FAILURE';

export const SET_SHOW_EXEC_LIST_INFO_BOX = 'SET_SHOW_EXEC_LIST_INFO_BOX';
export const SET_SHOW_EXEC_LIST_BANNER = 'SET_SHOW_EXEC_LIST_BANNER';

export const POST_SEND_EXECUTIVE_LIST_REQUEST = 'POST_SEND_EXECUTIVE_LIST_REQUEST';
export const POST_SEND_EXECUTIVE_LIST_SUCCESS = 'POST_SEND_EXECUTIVE_LIST_SUCCESS';
export const POST_SEND_EXECUTIVE_LIST_FAILURE = 'POST_SEND_EXECUTIVE_LIST_FAILURE';

export const GET_EXECUTIVE_LIST_FILTERS_REQUEST = 'GET_EXECUTIVE_LIST_FILTERS_REQUEST';
export const GET_EXECUTIVE_LIST_FILTERS_SUCCESS = 'GET_EXECUTIVE_LIST_FILTERS_SUCCESS';
export const GET_EXECUTIVE_LIST_FILTERS_FAILURE = 'GET_EXECUTIVE_LIST_FILTERS_FAILURE';
export const POST_EXECUTIVE_LIST_FILTERS_REQUEST = 'POST_EXECUTIVE_LIST_FILTERS_REQUEST';
export const POST_EXECUTIVE_LIST_FILTERS_SUCCESS = 'POST_EXECUTIVE_LIST_FILTERS_SUCCESS';
export const POST_EXECUTIVE_LIST_FILTERS_FAILURE = 'POST_EXECUTIVE_LIST_FILTERS_FAILURE';
export const PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST = 'PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST';
export const PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS = 'PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS';
export const PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE = 'PATCH_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE';
export const DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST = 'DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_REQUEST';
export const DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS = 'DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_SUCCESS';
export const DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE = 'DELETE_EXECUTIVE_LIST_FILTERS_BY_ID_FAILURE';

export const POST_EXECUTIVE_LIST_SEARCH_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_FAILURE';
export const POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST = 'POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_REQUEST';
export const POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS = 'POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_SUCCESS';
export const POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE = 'POST_EXECUTIVE_LIST_NO_MATCH_CORPORATION_CSV_FAILURE';
export const POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_AI_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_AI_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_AI_FAILURE';
export const POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE';
export const POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE';
export const POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE';
export const POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST = 'POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST';
export const POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS = 'POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS';
export const POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE = 'POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE';
export const GET_EXPORTED_LIST_REQUEST = 'GET_EXPORTED_LIST_REQUEST';
export const GET_EXPORTED_LIST_SUCCESS = 'GET_EXPORTED_LIST_SUCCESS';
export const GET_EXPORTED_LIST_FAILURE = 'GET_EXPORTED_LIST_FAILURE';
export const POST_EXECUTIVE_LIST_CSV_REQUEST = 'POST_EXECUTIVE_LIST_CSV_REQUEST';
export const POST_EXECUTIVE_LIST_CSV_SUCCESS = 'POST_EXECUTIVE_LIST_CSV_SUCCESS';
export const POST_EXECUTIVE_LIST_CSV_FAILURE = 'POST_EXECUTIVE_LIST_CSV_FAILURE';
export const GET_EXECUTIVE_LIST_UPDATE_REQUEST = 'GET_EXECUTIVE_LIST_UPDATE_REQUEST';
export const GET_EXECUTIVE_LIST_UPDATE_SUCCESS = 'GET_EXECUTIVE_LIST_UPDATE_SUCCESS';
export const GET_EXECUTIVE_LIST_UPDATE_FAILURE = 'GET_EXECUTIVE_LIST_UPDATE_FAILURE';

export const POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST = 'POST_EXECUTIVE_LIST_SALESFORCE_SYNC_REQUEST';
export const POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS = 'POST_EXECUTIVE_LIST_SALESFORCE_SYNC_SUCCESS';
export const POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE = 'POST_EXECUTIVE_LIST_SALESFORCE_SYNC_FAILURE';

//ng-sendings
export const GET_NG_SENDINGS_REQUEST = 'GET_NG_SENDINGS_REQUEST';
export const GET_NG_SENDINGS_SUCCESS = 'GET_NG_SENDINGS_SUCCESS';
export const GET_NG_SENDINGS_FAILURE = 'GET_NG_SENDINGS_FAILURE';
export const GET_NG_SENDINGS_BY_ID_REQUEST = 'GET_NG_SENDINGS_BY_ID_REQUEST';
export const GET_NG_SENDINGS_BY_ID_SUCCESS = 'GET_NG_SENDINGS_BY_ID_SUCCESS';
export const GET_NG_SENDINGS_BY_ID_FAILURE = 'GET_NG_SENDINGS_BY_ID_FAILURE';
export const PUT_NG_SENDINGS_REQUEST = 'PUT_NG_SENDINGS_REQUEST';
export const PUT_NG_SENDINGS_SUCCESS = 'PUT_NG_SENDINGS_SUCCESS';
export const PUT_NG_SENDINGS_FAILURE = 'PUT_NG_SENDINGS_FAILURE';
export const POST_NG_SENDINGS_REQUEST = 'POST_NG_SENDINGS_REQUEST';
export const POST_NG_SENDINGS_SUCCESS = 'POST_NG_SENDINGS_SUCCESS';
export const POST_NG_SENDINGS_FAILURE = 'POST_NG_SENDINGS_FAILURE';
export const POST_NG_SENDINGS_EXCEL_REQUEST = 'POST_NG_SENDINGS_EXCEL_REQUEST';
export const POST_NG_SENDINGS_EXCEL_SUCCESS = 'POST_NG_SENDINGS_EXCEL_SUCCESS';
export const POST_NG_SENDINGS_EXCEL_FAILURE = 'POST_NG_SENDINGS_EXCEL_FAILURE';
export const DELETE_NG_SENDINGS_REQUEST = 'DELETE_NG_SENDINGS_REQUEST';
export const DELETE_NG_SENDINGS_SUCCESS = 'DELETE_NG_SENDINGS_SUCCESS';
export const DELETE_NG_SENDINGS_FAILURE = 'DELETE_NG_SENDINGS_FAILURE';
export const DELETE_NG_SENDINGS_BY_ID_REQUEST = 'DELETE_NG_SENDINGS_BY_ID_REQUEST';
export const DELETE_NG_SENDINGS_BY_ID_SUCCESS = 'DELETE_NG_SENDINGS_BY_ID_SUCCESS';
export const DELETE_NG_SENDINGS_BY_ID_FAILURE = 'DELETE_NG_SENDINGS_BY_ID_FAILURE';

//other
export const INITIALIZE_MESSAGE = 'INITIALIZE_MESSAGE';
export const JOB_COMPLETED_REQUEST = 'JOB_COMPLETED_REQUEST';
export const JOB_COMPLETED_SUCCESS = 'JOB_COMPLETED_SUCCESS'; //ブロードキャストイベントのFAILはそもそも通知されないので存在しません。actionやreducerにも記載してません。
export const GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST = 'GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_REQUEST';
export const GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS = 'GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_SUCCESS';
export const GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE = 'GET_LETTER_ORDERS_LETTER_CONTENT_CHECK_FAILURE';

// timeline
export const GET_TIMELINE_STATUS_REQUEST = 'GET_TIMELINE_STATUS_REQUEST';
export const GET_TIMELINE_STATUS_SUCCESS = 'GET_TIMELINE_STATUS_SUCCESS';
export const GET_TIMELINE_STATUS_FAILURE = 'GET_TIMELINE_STATUS_FAILURE';
export const POST_TIMELINE_STATUS_REQUEST = 'POST_TIMELINE_STATUS_REQUEST';
export const POST_TIMELINE_STATUS_SUCCESS = 'POST_TIMELINE_STATUS_SUCCESS';
export const POST_TIMELINE_STATUS_FAILURE = 'POST_TIMELINE_STATUS_FAILURE';
export const DELETE_TIMELINE_STATUS_BY_ID_REQUEST = 'DELETE_TIMELINE_STATUS_BY_ID_REQUEST';
export const DELETE_TIMELINE_STATUS_BY_ID_SUCCESS = 'DELETE_TIMELINE_STATUS_BY_ID_SUCCESS';
export const DELETE_TIMELINE_STATUS_BY_ID_FAILURE = 'DELETE_TIMELINE_STATUS_BY_ID_FAILURE';
export const GET_RECORDING_DATA_REQUEST = 'GET_RECORDING_DATA_REQUEST';
export const GET_RECORDING_DATA_SUCCESS = 'GET_RECORDING_DATA_SUCCESS';
export const GET_RECORDING_DATA_FAILURE = 'GET_RECORDING_DATA_FAILURE';
export const GET_TIMELINE_STATUS_BY_ID_REQUEST = 'GET_TIMELINE_STATUS_BY_ID_REQUEST';
export const GET_TIMELINE_STATUS_BY_ID_SUCCESS = 'GET_TIMELINE_STATUS_BY_ID_SUCCESS';
export const GET_TIMELINE_STATUS_BY_ID_FAILURE = 'GET_TIMELINE_STATUS_BY_ID_FAILURE';

// order-dashboard
export const GET_APPOINT_NOTIFICATIONS_REQUEST = 'GET_APPOINT_NOTIFICATIONS_REQUEST';
export const GET_APPOINT_NOTIFICATIONS_SUCCESS = 'GET_APPOINT_NOTIFICATIONS_SUCCESS';
export const GET_APPOINT_NOTIFICATIONS_FAILURE = 'GET_APPOINT_NOTIFICATIONS_FAILURE';
export const GET_ORDERS_ACHIEVEMENT_REQUEST = 'GET_ORDERS_ACHIEVEMENT_REQUEST';
export const GET_ORDERS_ACHIEVEMENT_SUCCESS = 'GET_ORDERS_ACHIEVEMENT_SUCCESS';
export const GET_ORDERS_ACHIEVEMENT_FAILURE = 'GET_ORDERS_ACHIEVEMENT_FAILURE';
export const GET_ORDERS_OVERVIEW_REQUEST = 'GET_ORDERS_OVERVIEW_REQUEST';
export const GET_ORDERS_OVERVIEW_SUCCESS = 'GET_ORDERS_OVERVIEW_SUCCESS';
export const GET_ORDERS_OVERVIEW_FAILURE = 'GET_ORDERS_OVERVIEW_FAILURE';
export const GET_CALL_LIST_REQUEST = 'GET_CALL_LIST_REQUEST';
export const GET_CALL_LIST_SUCCESS = 'GET_CALL_LIST_SUCCESS';
export const GET_CALL_LIST_FAILURE = 'GET_CALL_LIST_FAILURE';
export const GET_REACTION_LIST_REQUEST = 'GET_REACTION_LIST_REQUEST';
export const GET_REACTION_LIST_SUCCESS = 'GET_REACTION_LIST_SUCCESS';
export const GET_REACTION_LIST_FAILURE = 'GET_REACTION_LIST_FAILURE';

// orders
export const GET_ORDERS_LIST_REQUEST = 'GET_ORDERS_LIST_REQUEST';
export const GET_ORDERS_LIST_SUCCESS = 'GET_ORDERS_LIST_SUCCESS';
export const GET_ORDERS_LIST_FAILURE = 'GET_ORDERS_LIST_FAILURE';
export const GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST = 'GET_CURRENT_MONTH_ORDERS_OVERVIEW_REQUEST';
export const GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS = 'GET_CURRENT_MONTH_ORDERS_OVERVIEW_SUCCESS';
export const GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE = 'GET_CURRENT_MONTH_ORDERS_OVERVIEW_FAILURE';
export const GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST = 'GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_REQUEST';
export const GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS = 'GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_SUCCESS';
export const GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE = 'GET_SELECT_YEAR_MONTH_ORDERS_OVERVIEW_FAILURE';
export const GET_ORDER_BY_ID_REQUEST = 'GET_ORDER_BY_ID_REQUEST';
export const GET_ORDER_BY_ID_SUCCESS = 'GET_ORDER_BY_ID_SUCCESS';
export const GET_ORDER_BY_ID_FAILURE = 'GET_ORDER_BY_ID_FAILURE';
export const GET_ORDER_ADDRESSES_REQUEST = 'GET_ORDER_ADDRESSES_REQUEST';
export const GET_ORDER_ADDRESSES_SUCCESS = 'GET_ORDER_ADDRESSES_SUCCESS';
export const GET_ORDER_ADDRESSES_FAILURE = 'GET_ORDER_ADDRESSES_FAILURE';

// download-history
// 一覧（サマリー: 同一エクスポート注文を1行に集約。GET /executive_export_histories/summary）
export const GET_DOWNLOAD_HISTORY_REQUEST = 'GET_DOWNLOAD_HISTORY_REQUEST';
export const GET_DOWNLOAD_HISTORY_SUCCESS = 'GET_DOWNLOAD_HISTORY_SUCCESS';
export const GET_DOWNLOAD_HISTORY_FAILURE = 'GET_DOWNLOAD_HISTORY_FAILURE';
// 明細（注文ごとのエクスポート対象一覧。GET /executive_export_histories）
export const GET_DOWNLOAD_HISTORY_DETAIL_REQUEST = 'GET_DOWNLOAD_HISTORY_DETAIL_REQUEST';
export const GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS = 'GET_DOWNLOAD_HISTORY_DETAIL_SUCCESS';
export const GET_DOWNLOAD_HISTORY_DETAIL_FAILURE = 'GET_DOWNLOAD_HISTORY_DETAIL_FAILURE';
// 概要（注文数・ダウンロード件数。GET /executive_export_histories/overview）
export const GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST = 'GET_DOWNLOAD_HISTORY_OVERVIEW_REQUEST';
export const GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS = 'GET_DOWNLOAD_HISTORY_OVERVIEW_SUCCESS';
export const GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE = 'GET_DOWNLOAD_HISTORY_OVERVIEW_FAILURE';

// letter-orders
export const POST_LETTER_ORDERS_ORDER_REQUEST = 'POST_LETTER_ORDERS_ORDER_REQUEST';
export const POST_LETTER_ORDERS_ORDER_SUCCESS = 'POST_LETTER_ORDERS_ORDER_SUCCESS';
export const POST_LETTER_ORDERS_ORDER_FAILURE = 'POST_LETTER_ORDERS_ORDER_FAILURE';
export const GET_LETTER_ORDERS_LIST_REQUEST = 'GET_LETTER_ORDERS_LIST_REQUEST';
export const GET_LETTER_ORDERS_LIST_SUCCESS = 'GET_LETTER_ORDERS_LIST_SUCCESS';
export const GET_LETTER_ORDERS_LIST_FAILURE = 'GET_LETTER_ORDERS_LIST_FAILURE';
export const GET_LETTER_ORDERS_ADDRESSES_REQUEST = 'GET_LETTER_ORDERS_ADDRESSES_REQUEST';
export const GET_LETTER_ORDERS_ADDRESSES_SUCCESS = 'GET_LETTER_ORDERS_ADDRESSES_SUCCESS';
export const GET_LETTER_ORDERS_ADDRESSES_FAILURE = 'GET_LETTER_ORDERS_ADDRESSES_FAILURE';
export const POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST = 'POST_LETTER_ORDERS_SALESFORCE_SYNC_REQUEST';
export const POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS = 'POST_LETTER_ORDERS_SALESFORCE_SYNC_SUCCESS';
export const POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE = 'POST_LETTER_ORDERS_SALESFORCE_SYNC_FAILURE';
export const GET_DELAY_LETTER_ORDERS_REQUEST = 'GET_DELAY_LETTER_ORDERS_REQUEST';
export const GET_DELAY_LETTER_ORDERS_SUCCESS = 'GET_DELAY_LETTER_ORDERS_SUCCESS';
export const GET_DELAY_LETTER_ORDERS_FAILURE = 'GET_DELAY_LETTER_ORDERS_FAILURE';
export const SET_SHOW_SEND_ORDER_INFO_BOX = 'SET_SHOW_SEND_ORDER_INFO_BOX';

// follow-call-orders
export const POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST = 'POST_FOLLOW_CALL_ORDERS_ORDER_REQUEST';
export const POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS = 'POST_FOLLOW_CALL_ORDERS_ORDER_SUCCESS';
export const POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE = 'POST_FOLLOW_CALL_ORDERS_ORDER_FAILURE';
export const GET_FOLLOW_CALL_ORDER_LIST_REQUEST = 'GET_FOLLOW_CALL_ORDER_LIST_REQUEST';
export const GET_FOLLOW_CALL_ORDER_LIST_SUCCESS = 'GET_FOLLOW_CALL_ORDER_LIST_SUCCESS';
export const GET_FOLLOW_CALL_ORDER_LIST_FAILURE = 'GET_FOLLOW_CALL_ORDER_LIST_FAILURE';
export const POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST = 'POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_REQUEST';
export const POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS = 'POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_SUCCESS';
export const POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE = 'POST_FOLLOW_CALL_ORDERS_SALESFORCE_SYNC_FAILURE';

export const SET_SHOW_DEMO_DATA = 'SET_SHOW_DEMO_DATA';

// questionnaire
export const POST_FOLLOW_CALL_APPOINTMENT_REQUEST = 'POST_FOLLOW_CALL_APPOINTMENT_REQUEST';
export const POST_FOLLOW_CALL_APPOINTMENT_SUCCESS = 'POST_FOLLOW_CALL_APPOINTMENT_SUCCESS';
export const POST_FOLLOW_CALL_APPOINTMENT_FAILURE = 'POST_FOLLOW_CALL_APPOINTMENT_FAILURE';

// current_person_status
export const GET_CURRENT_PERSON_ALL_STATUS_REQUEST = 'GET_CURRENT_PERSON_ALL_STATUS_REQUEST';
export const GET_CURRENT_PERSON_ALL_STATUS_SUCCESS = 'GET_CURRENT_PERSON_ALL_STATUS_SUCCESS';
export const GET_CURRENT_PERSON_ALL_STATUS_FAILURE = 'GET_CURRENT_PERSON_ALL_STATUS_FAILURE';
export const GET_CURRENT_PERSON_STATUS_REQUEST = 'GET_CURRENT_PERSON_STATUS_REQUEST';
export const GET_CURRENT_PERSON_STATUS_SUCCESS = 'GET_CURRENT_PERSON_STATUS_SUCCESS';
export const GET_CURRENT_PERSON_STATUS_FAILURE = 'GET_CURRENT_PERSON_STATUS_FAILURE';
export const GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST = 'GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST';
export const GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS = 'GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS';
export const GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE = 'GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE';
export const GET_PERSON_LEAD_NOTE_STATUS_REQUEST = 'GET_PERSON_LEAD_NOTE_STATUS_REQUEST';
export const GET_PERSON_LEAD_NOTE_STATUS_SUCCESS = 'GET_PERSON_LEAD_NOTE_STATUS_SUCCESS';
export const GET_PERSON_LEAD_NOTE_STATUS_FAILURE = 'GET_PERSON_LEAD_NOTE_STATUS_FAILURE';
export const GET_PERSON_QR_CODE_STATUS_REQUEST = 'GET_PERSON_QR_CODE_STATUS_REQUEST';
export const GET_PERSON_QR_CODE_STATUS_SUCCESS = 'GET_PERSON_QR_CODE_STATUS_SUCCESS';
export const GET_PERSON_QR_CODE_STATUS_FAILURE = 'GET_PERSON_QR_CODE_STATUS_FAILURE';

// letter-corrections
export const POST_LETTER_CORRECTIONS_CORRECT_REQUEST = 'POST_LETTER_CORRECTIONS_CORRECT_REQUEST';
export const POST_LETTER_CORRECTIONS_CORRECT_SUCCESS = 'POST_LETTER_CORRECTIONS_CORRECT_SUCCESS';
export const POST_LETTER_CORRECTIONS_CORRECT_FAILURE = 'POST_LETTER_CORRECTIONS_CORRECT_FAILURE';

// letter-auto-generate
export const POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST = 'POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST';
export const POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS = 'POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS';
export const POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE = 'POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE';

// order contacts
export const DELETE_ORDER_CONTACTS_REQUEST = 'DELETE_ORDER_CONTACTS_REQUEST';
export const DELETE_ORDER_CONTACTS_SUCCESS = 'DELETE_ORDER_CONTACTS_SUCCESS';
export const DELETE_ORDER_CONTACTS_FAILURE = 'DELETE_ORDER_CONTACTS_FAILURE';
export const GET_ORDER_CONTACTS_REQUEST = 'GET_ORDER_CONTACTS_REQUEST';
export const GET_ORDER_CONTACTS_SUCCESS = 'GET_ORDER_CONTACTS_SUCCESS';
export const GET_ORDER_CONTACTS_FAILURE = 'GET_ORDER_CONTACTS_FAILURE';
export const POST_ORDER_CONTACTS_REQUEST = 'POST_ORDER_CONTACTS_REQUEST';
export const POST_ORDER_CONTACTS_SUCCESS = 'POST_ORDER_CONTACTS_SUCCESS';
export const POST_ORDER_CONTACTS_FAILURE = 'POST_ORDER_CONTACTS_FAILURE';

// SALESFORCE
export const GET_SALESFORCE_DESCRIBE_REQUEST = 'GET_SALESFORCE_DESCRIBE_REQUEST';
export const GET_SALESFORCE_DESCRIBE_SUCCESS = 'GET_SALESFORCE_DESCRIBE_SUCCESS';
export const GET_SALESFORCE_DESCRIBE_FAILURE = 'GET_SALESFORCE_DESCRIBE_FAILURE';
export const GET_SALESFORCE_PREVIEW_REQUEST = 'GET_SALESFORCE_PREVIEW_REQUEST';
export const GET_SALESFORCE_PREVIEW_SUCCESS = 'GET_SALESFORCE_PREVIEW_SUCCESS';
export const GET_SALESFORCE_PREVIEW_FAILURE = 'GET_SALESFORCE_PREVIEW_FAILURE';
export const GET_SALESFORCE_USERINFO_REQUEST = 'GET_SALESFORCE_USERINFO_REQUEST';
export const GET_SALESFORCE_USERINFO_SUCCESS = 'GET_SALESFORCE_USERINFO_SUCCESS';
export const GET_SALESFORCE_USERINFO_FAILURE = 'GET_SALESFORCE_USERINFO_FAILURE';
export const POST_SALESFORCE_REVOKE_REQUEST = 'POST_SALESFORCE_REVOKE_REQUEST';
export const POST_SALESFORCE_REVOKE_SUCCESS = 'POST_SALESFORCE_REVOKE_SUCCESS';
export const POST_SALESFORCE_REVOKE_FAILURE = 'POST_SALESFORCE_REVOKE_FAILURE';
export const POST_SALESFORCE_SYNC_REQUEST = 'POST_SALESFORCE_SYNC_REQUEST';
export const POST_SALESFORCE_SYNC_SUCCESS = 'POST_SALESFORCE_SYNC_SUCCESS';
export const POST_SALESFORCE_SYNC_FAILURE = 'POST_SALESFORCE_SYNC_FAILURE';

export const GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST = 'GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST';
export const GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS = 'GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS';
export const GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE = 'GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE';
export const GET_SALESFORCE_SYNC_LAST_UPDATE_REQUEST = 'GET_SALESFORCE_SYNC_LAST_UPDATE_REQUEST';
export const GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS = 'GET_SALESFORCE_SYNC_LAST_UPDATE_SUCCESS';
export const GET_SALESFORCE_SYNC_LAST_UPDATE_FAILURE = 'GET_SALESFORCE_SYNC_LAST_UPDATE_FAILURE';
export const GET_SALESFORCE_LISTVIEWS_REQUEST = 'GET_SALESFORCE_LISTVIEWS_REQUEST';
export const GET_SALESFORCE_LISTVIEWS_SUCCESS = 'GET_SALESFORCE_LISTVIEWS_SUCCESS';
export const GET_SALESFORCE_LISTVIEWS_FAILURE = 'GET_SALESFORCE_LISTVIEWS_FAILURE';
export const POST_SALESFORCE_CONFIG_REQUEST = 'POST_SALESFORCE_CONFIG_REQUEST';
export const POST_SALESFORCE_CONFIG_SUCCESS = 'POST_SALESFORCE_CONFIG_SUCCESS';
export const POST_SALESFORCE_CONFIG_FAILURE = 'POST_SALESFORCE_CONFIG_FAILURE';
export const GET_SALESFORCE_CONFIG_REQUEST = 'GET_SALESFORCE_CONFIG_REQUEST';
export const GET_SALESFORCE_CONFIG_SUCCESS = 'GET_SALESFORCE_CONFIG_SUCCESS';
export const GET_SALESFORCE_CONFIG_FAILURE = 'GET_SALESFORCE_CONFIG_FAILURE';

export const GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST = 'GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST';
export const GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS = 'GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS';
export const GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE = 'GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE';
export const POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST = 'POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST';
export const POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS = 'POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS';
export const POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE = 'POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE';

export const GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST = 'GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST';
export const GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS = 'GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS';
export const GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE = 'GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE';

export const GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST = 'GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_REQUEST';
export const GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS = 'GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_SUCCESS';
export const GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE = 'GET_SALESFORCE_DESCRIBE_TIMELINE_STATUS_EXPORT_FAILURE';
export const POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST = 'POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_REQUEST';
export const POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS = 'POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_SUCCESS';
export const POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE = 'POST_SALESFORCE_EXPORT_MAPPINGS_TIMELINE_STATUS_FAILURE';

export const GET_SALESFORCE_IMPORT_HISTORIES_REQUEST = 'GET_SALESFORCE_IMPORT_HISTORIES_REQUEST';
export const GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS = 'GET_SALESFORCE_IMPORT_HISTORIES_SUCCESS';
export const GET_SALESFORCE_IMPORT_HISTORIES_FAILURE = 'GET_SALESFORCE_IMPORT_HISTORIES_FAILURE';
export const GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST = 'GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_REQUEST';
export const GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS = 'GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_SUCCESS';
export const GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE = 'GET_SALESFORCE_IMPORT_HISTORIES_BY_ID_FAILURE';
export const GET_SALESFORCE_EXPORT_HISTORIES_REQUEST = 'GET_SALESFORCE_EXPORT_HISTORIES_REQUEST';
export const GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS = 'GET_SALESFORCE_EXPORT_HISTORIES_SUCCESS';
export const GET_SALESFORCE_EXPORT_HISTORIES_FAILURE = 'GET_SALESFORCE_EXPORT_HISTORIES_FAILURE';
export const GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST = 'GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_REQUEST';
export const GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS = 'GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_SUCCESS';
export const GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE = 'GET_SALESFORCE_EXPORT_HISTORIES_BY_ID_FAILURE';

export const GET_USER_MAILS_REQUEST = 'GET_USER_MAILS_REQUEST';
export const GET_USER_MAILS_SUCCESS = 'GET_USER_MAILS_SUCCESS';
export const GET_USER_MAILS_FAILURE = 'GET_USER_MAILS_FAILURE';
export const POST_USER_MAILS_REQUEST = 'POST_USER_MAILS_REQUEST';
export const POST_USER_MAILS_SUCCESS = 'POST_USER_MAILS_SUCCESS';
export const POST_USER_MAILS_FAILURE = 'POST_USER_MAILS_FAILURE';
export const PUT_USER_MAILS_REQUEST = 'PUT_USER_MAILS_REQUEST';
export const PUT_USER_MAILS_SUCCESS = 'PUT_USER_MAILS_SUCCESS';
export const PUT_USER_MAILS_FAILURE = 'PUT_USER_MAILS_FAILURE';
export const DELETE_USER_MAILS_BY_ID_REQUEST = 'DELETE_USER_MAILS_BY_ID_REQUEST';
export const DELETE_USER_MAILS_BY_ID_SUCCESS = 'DELETE_USER_MAILS_BY_ID_SUCCESS';
export const DELETE_USER_MAILS_BY_ID_FAILURE = 'DELETE_USER_MAILS_BY_ID_FAILURE';
export const PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST = 'PATCH_USERS_EMAIL_NOTIFICATION_FLAG_REQUEST';
export const PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS = 'PATCH_USERS_EMAIL_NOTIFICATION_FLAG_SUCCESS';
export const PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE = 'PATCH_USERS_EMAIL_NOTIFICATION_FLAG_FAILURE';
export const POST_USERS_UPDATE_PASSWORD_REQUEST = 'POST_USERS_UPDATE_PASSWORD_REQUEST';
export const POST_USERS_UPDATE_PASSWORD_SUCCESS = 'POST_USERS_UPDATE_PASSWORD_SUCCESS';
export const POST_USERS_UPDATE_PASSWORD_FAILURE = 'POST_USERS_UPDATE_PASSWORD_FAILURE';
export const GET_PASSWORD_SECURITY_QUESTION_REQUEST = 'GET_PASSWORD_SECURITY_QUESTION_REQUEST';
export const GET_PASSWORD_SECURITY_QUESTION_SUCCESS = 'GET_PASSWORD_SECURITY_QUESTION_SUCCESS';
export const GET_PASSWORD_SECURITY_QUESTION_FAILURE = 'GET_PASSWORD_SECURITY_QUESTION_FAILURE';
export const TOGGLE_SYSTEM_NOTIFICATION_DIALOG = 'TOGGLE_SYSTEM_NOTIFICATION_DIALOG';
export const TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG = 'TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG';
export const SAML_AUTHENTICATED = 'SAML_AUTHENTICATED';

// corporation_tel_researches
export const GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST = 'GET_RESEARCHED_TEL_HAS_DEPARTMENTS_REQUEST';
export const GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS = 'GET_RESEARCHED_TEL_HAS_DEPARTMENTS_SUCCESS';
export const GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE = 'GET_RESEARCHED_TEL_HAS_DEPARTMENTS_FAILURE';

// ip_check
export const POST_IP_CHECK_REQUEST = 'POST_IP_CHECK_REQUEST';
export const POST_IP_CHECK_SUCCESS = 'POST_IP_CHECK_SUCCESS';
export const POST_IP_CHECK_FAILURE = 'POST_IP_CHECK_FAILURE';

// industry_minor_category_ids
export const GET_INDUSTRY_CATEGORY_LIST_REQUEST = 'GET_INDUSTRY_CATEGORY_LIST_REQUEST';
export const GET_INDUSTRY_CATEGORY_LIST_SUCCESS = 'GET_INDUSTRY_CATEGORY_LIST_SUCCESS';
export const GET_INDUSTRY_CATEGORY_LIST_FAILURE = 'GET_INDUSTRY_CATEGORY_LIST_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js